import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div``;

export const Inner = styled.div`
    padding: 32px 0 0;
`;

export const InfoBar = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 75px 0;
`;

export const ListingCount = styled.div`
    font-size: 30px;
    color: ${colors.brandMid};
`;

export const InfoBarActions = styled.div`
    display: flex;
`;

export const LoadMore = styled.div`
    margin-top: 32px;
    text-align: center;
`;

export const Listings = styled.div`
`;
